import TimezoneButton from './TimezoneButton';
import { ThemeProvider } from '@fluentui/react-theme-provider';
import { IButtonStyles } from '@fluentui/react/lib/Button';
import { Icon } from '@fluentui/react/lib/Icon';
import { ITheme } from '@uifabric/styling';
import { observer } from 'mobx-react-lite';
import { updateAllDay } from 'owa-calendar-compose-form-actions';
import getFullComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getFullComposeViewState';
import { lazyRenderSpeedyMeetingsTeachingUI } from 'owa-calendar-compose-form-utils';
import SmartDateSelector from 'owa-calendar-compose-form-view/lib/components/SmartDateSelector';
import AllDayToggle from 'owa-calendar-forms-common/lib/components/AllDayToggle';
import { TimeChangeActionType } from 'owa-calendar-helpers-types/lib/TimeChangeActionType';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { ControlIcons } from 'owa-control-icons';
import * as React from 'react';
import { getIsNarrowFullCompose } from '../selectors/getIsNarrowFullCompose';

let styles = require('./FullComposeLeftPane.scss');

export interface TimeRowProps {
    event: CalendarEvent;
    calendarTheme: ITheme;
    buttonStyle: IButtonStyles;
    calendarColorScheme: ColorScheme;
}

export default observer(function TimeRow(props: TimeRowProps) {
    const fullComposeViewState = getFullComposeViewState();
    const { event, calendarTheme, buttonStyle, calendarColorScheme } = props;
    const isNarrow = getIsNarrowFullCompose();
    const renderSpeedyMeetingsTeachingUI = lazyRenderSpeedyMeetingsTeachingUI.tryImportForRender();
    const renderAfterDateRow = renderSpeedyMeetingsTeachingUI
        ? target =>
              renderSpeedyMeetingsTeachingUI(
                  target,
                  fullComposeViewState.shouldAdjustStartTimeEndTime
              )
        : undefined;

    return (
        <div className={isNarrow ? styles.dynamicTimeRow : styles.row}>
            <div className={styles.leftSideTimeRow}>
                <Icon iconName={ControlIcons.Clock} className={styles.icon} />
                <SmartDateSelector
                    className={styles.dateSelector}
                    isNarrow={isNarrow}
                    showTimeZones={
                        !event.IsAllDayEvent && fullComposeViewState.showDateSelectorTimeZones
                    }
                    timeChangeActionType={TimeChangeActionType.FullComposeTimeControls}
                    disabled={!fullComposeViewState.uiEnabled}
                    renderAfterDateRow={renderAfterDateRow}
                />
            </div>
            <div className={isNarrow ? styles.dynamicRightSideTimeRow : styles.rightSideTimeRow}>
                {!event.IsAllDayEvent && (
                    <ThemeProvider theme={calendarTheme}>
                        <TimezoneButton buttonStyle={buttonStyle} />
                    </ThemeProvider>
                )}
                {!fullComposeViewState.showDateSelectorTimeZones && (
                    <AllDayToggle
                        isAllDay={event.IsAllDayEvent}
                        onAllDayToggled={onAllDayToggled}
                        colorScheme={calendarColorScheme}
                        className={styles.allDayControl}
                        isDarkMode={fullComposeViewState.isDarkMode}
                        disabled={!fullComposeViewState.uiEnabled}
                    />
                )}
            </div>
        </div>
    );
});

function onAllDayToggled(isChecked) {
    updateAllDay(isChecked, true /* isAllDayEventExplicitlySet */);
}
